import {O} from "web-vcore";
import {computed} from "mobx";
import {EngineConfig} from "../../../Server/DB/engineConfigs/@EngineConfig.js";
import {LogType} from "../../../UI/Tools/@Shared/LogEntry.js";
import {SessionEvent} from "../../../Engine/LiveSession/SessionEvent.js";
import {LaunchType} from "../../../Server/DB/engineConfigs/@EngineConfig/@EC_ModeSwitcher.js";
import {SessionCoreData} from "../../../Server/DB/sessions/@Session.js";
import {AlarmSequence} from "../../../Server/DB/engineConfigs/@EngineConfig/Alarms/@AlarmConfig.js";
import {EngineConfigVariant} from "../../../Server/DB/engineConfigs/@EngineConfig/@Shared/EngineConfigVariant.js";
import {PromptPool} from "../../../Server/DB/engineConfigs/@EngineConfig/@EC_Visualization.js";
import {ignore} from "mobx-sync";

export enum EngineTab {
	Host = 10,
	Client = 20,
	Log = 30,
	Timeline = 40,
	Stats = 50,
}

/*export enum EngineContext {
	WebOnly = 10,
	WebAndNative = 20,
	NativeOnly = 30,
}*/

export enum HostClientChannel {
	RealtimeDatabase = 10,
	Websockets = 20,
}
export const HostClientChannel_shortNames = {
	[HostClientChannel.RealtimeDatabase]: "RTD",
	[HostClientChannel.Websockets]: "Websockets",
};

export enum HostFindType {
	Auto = 10,
	//Select = 20,
	Manual = 30,
}

export class ConfigState {
	@O accessor tab = EngineTab.Host;

	// general/engine
	// ==========

	//localConfig: EngineConfig;
	@O accessor selectedConfig: string;
	@O @ignore accessor variants_copiedVariant: EngineConfigVariant|n;
	@O @ignore accessor alarms_copiedSequence: AlarmSequence|n;
	@O @ignore accessor viz_copiedPromptPool: PromptPool|n;
	@O accessor spatialAudioBake_duration = 60; // in seconds
	@O accessor spatialAudioBake_volumeOverride = 0; // ignored if <=0
	@O accessor allowClientConnections = false;
	@O accessor showNotes = true;

	// client
	// ==========

	//engineContext = EngineContext.WebAndNative;
	@O accessor remote_channel = HostClientChannel.RealtimeDatabase;
	@O accessor remote_hostFindType = HostFindType.Auto;
	@O accessor remote_hostIPAddressAndPort = "192.168.0.100:3502";
	@O @ignore accessor remote_autoConnect = false;
	@O accessor remoteConfig = new EngineConfig({}, true);

	/*remote_snoozeFailTrigger_volumeKeys = true;
	remote_snoozeFailTrigger_micLoudness = false;
	remote_snoozeFailTrigger_micLoudness_loudness = .1;*/

	// these are currently only used as trackers for notifying when...
	// * the session-vars are set to a whole new object/value (or null)
	@O accessor liveSession_setAt: number;
	// * a log-entry is added
	@O @ignore accessor liveSession_loggedAt: number;
	@computed get liveSession_setOrLoggedAt() { return Math.max(this.liveSession_setAt, this.liveSession_loggedAt); }
	@O accessor liveSession_recoveryInfo: SessionCoreData|n;

	// log
	// ==========

	@O accessor logTypesToShow = [LogType.Action, LogType.Event_Large];
	@O accessor include_enabled = false;
	@O accessor include_text = "";
	@O accessor exclude_enabled = false;
	@O accessor exclude_text = "";

	// stats
	// ===========

	@O accessor evaluatorName: string;
}